export enum NotificationType {
  InspectionReport = 1,
  AllItemsExcelExport = 2,
  InspectionExcelExport = 3,
  InspectionAttachmentsDownload = 4,
  InspectionItemAttachmentsDownload = 5,
  LopItemAttachmentsDownload = 6
}
